import create from 'zustand';

import { ModalProps } from '~components/Modal';

interface ModalStoreOptions extends Partial<Omit<ModalProps, 'isOpen' | 'handleClose'>> {}
export interface ModalStore extends ModalStoreOptions {
  isOpen: boolean;
  modalProps: ModalStoreOptions;
  modalShow: (modalInfo: ModalStoreOptions) => void;
  modalClose: () => void;
}

const initialState: ModalStoreOptions = {
  title: undefined,
  subTitle: undefined,
  confirmButtonText: undefined,
  handleConfirm: undefined,
  cancelButtonText: undefined,
  handleCancel: undefined,
  confirmButtonVariant: undefined,
};

const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  modalProps: {
    ...initialState,
  },
  modalShow: ({
    title,
    subTitle,
    confirmButtonText,
    handleConfirm,
    cancelButtonText,
    handleCancel,
    confirmButtonVariant,
  }) =>
    set({
      isOpen: true,
      modalProps: {
        title,
        subTitle,
        confirmButtonText,
        handleConfirm,
        cancelButtonText,
        handleCancel,
        confirmButtonVariant,
      },
    }),
  modalClose: () => set(() => ({ isOpen: false, modalProps: initialState })),
}));

export default useModalStore;
